"use strict";

new Vue({
    el: "#engarde"
});


// WEBPACK FOOTER //
// ./frontend/js/app.js